import { LogoutOutlined, UsbOutlined, UserOutlined, InfoCircleOutlined, ShopOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import React from 'react'
import { withRouter } from '../../utils/router'
import { isAuthenticated, getLoginUser, logout } from '../../utils/session'
import { OBJECT_STORAGE_URL } from '../../utils/constants'


//withRouter一定要写在前面，不然路由变化不会反映到props中去
class ManageHeader extends React.Component {
    state = {
        icon: 'arrows-alt',
        count: 100,
    }

    updatePage(path) {
        this.props.router.navigate(path);
    }

    logout() {
        logout();
        this.props.router.navigate(this.props.router.location.pathname);
    }

    toggle = () => {
        this.props.onToggle()
    }

    render() {
        const user = getLoginUser();
        const notLogin = (
            <Button onClick={() => this.updatePage('/login')} type="primary" shape="round" style={{ height: "30px", marginTop: "10px", color: "#03b8cf", backgroundColor: "#ddf3f5" }}>登录</Button>
        );
        const items = [
            {
                label: <span style={{ color: '#666' }}>{`你好 ${user.username}`}</span>,
                key: '0',
            }, {
                type: 'divider',
            }, {
                label: <a href="/manage"><ShopOutlined />&nbsp;我的空间</a>,
                key: '5',
            }, {
                type: 'divider',
            }, {
                label: <a href="/profile/info"><UserOutlined />&nbsp;个人中心</a>,
                key: '1',
            }, {
                label: <a href="/profile/update"><InfoCircleOutlined />&nbsp;更新信息</a>,
                key: '2',
            }, {
                label: <a href="/profile/password"><UsbOutlined />&nbsp;修改密码</a>,
                key: '3',
            }, {
                label: <span onClick={() => this.logout()}><LogoutOutlined />&nbsp;退出登录</span>,
                key: '4',
            }
        ];
        const login = (
            <Dropdown menu={{ items }}>
                <img style={{ width: "30px", height: "30px" }} src={user.avatar || OBJECT_STORAGE_URL.DEFAULT_USER_AVATAR} alt="" />
            </Dropdown>
        );
        return (
            <div id='headerbar'>
                <div style={{ lineHeight: '64px', float: 'left', paddingBottom: '10px' }} onClick={this.toggle}>
                    {this.props.collapsed ? <MenuUnfoldOutlined style={{ fontSize: '20px' }} /> : <MenuFoldOutlined style={{ fontSize: '20px' }} />}
                </div>
                <div style={{ lineHeight: '64px', float: 'right', paddingBottom: '10px' }}>
                    {isAuthenticated() ? login : notLogin}
                </div>
            </div>
        )
    }
}

export default withRouter(ManageHeader)